import { AxiosResponse } from 'axios';
import { Kelas } from '../../entities/Kelas';

export class KelasDataMapper {
  public convertKelasDataFromApi(
    result: AxiosResponse<any>
  ): Kelas[] {
    const { data } = result.data;

    let kelas: Kelas[] = [];

    data.map((k: any) => {
      return kelas.push(
        new Kelas(
          k.kelas
        )
      );
    });

    return kelas;
  }
}
